import { Func } from '@skylab-shared/types';

export const transformObject = <T>(...functions: ((arg: T) => T)[]) => (base: T) => functions.reduce((arg, fn) => fn(arg), base);

export const memoize = <T = any, R = void>(fn: Func<T, R>) => {
    const cache = new Map();
    const cached = function (this: any, val: T) {
    return cache.has(val)
        ? cache.get(val)
        : cache.set(val, fn.call(this, val)) && cache.get(val);
    };
    cached.cache = cache;
    return cached;
};